import React, {useCallback, useContext, useEffect, useState} from "react";
import _css from "./SideNav.module.scss";
import {Button, ButtonVariant, Grid, List, ListItem} from "@patternfly/react-core";
import {ArrowLeftIcon, CloseIcon} from "@patternfly/react-icons";
import {useLocation} from "react-router-dom";
import {useNavigate} from "react-router-dom";
import {SessionsContext, SideBarNavContext} from "contexts";
import {SignInForm} from "components";
//import {decodeJwtToken} from "modules/security"

interface Props {
}

const SideNav: React.FC<Props> = () => {

    const navigate = useNavigate();
    const location = useLocation()
    const {
        navData,
        setNavData
    } = useContext(SideBarNavContext);
    const {
        sess,
        setSess
    } = useContext(SessionsContext);
    const [ login, isLogin ] = useState<boolean>(false);


    const toggleSideBar = () => {
        setNavData({ active : !navData.active })
    }

    useEffect(() => {
        if(sess && login){
            isLogin(false);
            setTimeout(() => {
                setNavData({ active : true });
            },100);
        }
        // eslint-disable-next-line
    }, [ sess ])

    const logoutSession = () => {
        localStorage.removeItem("x-access-token")
        setSess(null);
        navigate("/");
    }

    const toggleSideBarFromSigInForm = useCallback((isOpen) => {
        setNavData({ active : isOpen })
        isLogin(isOpen)
        // eslint-disable-next-line
    }, [ isLogin ])

    return (
        <React.Fragment>
            {navData && navData.active &&
            <div className={_css.container}>
                {login &&
                <React.Fragment>

                    <div className={_css.login_form}>
                        <ArrowLeftIcon className={_css.back_icon} onClick={() => isLogin(false)}/>
                        {!sess &&
                        <SignInForm
                            toggleSideBarFromSigInForm={toggleSideBarFromSigInForm}
                            isNav
                        />}
                        {sess &&(
                            <ListItem
                                className={`${_css.mon_espace} ${location.pathname === "/space" ? _css.text_list : ""}`}
                                onClick={() => {
                                navigate("/space");
                                setTimeout(() => toggleSideBar(), 300);
                                }}
                            >
                                <div>Mon espace</div>
                            </ListItem>
                        )}
                    </div>
                </React.Fragment>}
                {!login &&
                <React.Fragment>
                    <List className={_css.options}>
                        <ListItem><CloseIcon onClick={toggleSideBar}/></ListItem>
                        {sess && (
                            <ListItem
                            className={location.pathname === "/space" ? _css.text_list : ""}
                            onClick={() => {
                                navigate("/space");
                                setTimeout(() => toggleSideBar(), 300);
                            }}
                            >
                            <div>Mon espace</div>
                            </ListItem>
                        )}
                        <ListItem
                            className={(location && location.pathname === "/") ? _css.text_list : ""}
                            onClick={() => {
                                navigate("/")
                                setTimeout(() => toggleSideBar(), 300)
                            }}
                        >
                            <div>Accueil</div>
                        </ListItem>
                        <ListItem
                            className={(location && location.pathname === "/offers") ? _css.text_list : ""}
                            onClick={() => {
                                navigate("/offers")
                                setTimeout(() => toggleSideBar(), 300)
                            }}
                        >
                            <div>Les Offres</div>
                        </ListItem>
                        <ListItem
                            className={(location && location.pathname === "/pitons.bank") ? _css.text_list : ""}
                            onClick={() => {
                                navigate("/pitons.bank")
                                setTimeout(() => toggleSideBar(), 300)
                            }}
                        >
                            <div>Banque à pitons</div>
                        </ListItem>
                        <ListItem
                            className={(location && location.pathname === "/joinus") ? _css.text_list : ""}
                            onClick={() => {
                                navigate("/joinus")
                                setTimeout(() => toggleSideBar(), 300)
                            }}
                        >
                            <div>Nous Joindre</div>
                        </ListItem>
                        <ListItem
                            className={(location && location.pathname === "/blogue.chronics") ? _css.text_list : ""}
                            onClick={() => {
                                navigate("/blogue.chronics")
                                setTimeout(() => toggleSideBar(), 300)
                            }}
                        >
                            <div>Communiqués</div>
                        </ListItem>
                    </List>
                    <Grid hasGutter className={_css.bottom_buttons}>
                        {!sess &&
                        <button onClick={() => {
                            navigate("/register/user")
                            setTimeout(() => toggleSideBar(), 300)
                        }}>INSCRIPTION INDIVIDU</button>}
                        {!sess && <button
                            onClick={() => {
                            navigate("/sign_in");
                            setTimeout(() => toggleSideBar(), 300);
                            }}
                        >
                            OUVRIR UNE SESSION
                        </button>}
                        {sess &&
                        <Button
                            onClick={logoutSession}
                            isBlock
                            variant={ButtonVariant.link}
                            component={"a"}
                        >Se déconnecter</Button>}
                    </Grid>
                </React.Fragment>}
            </div>
            }
        </React.Fragment>
    )
}

export {SideNav}
